import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from './select';
import {
  getWeek,
  getDay,
  getMonth,
  getWeekDayShort,
  getWeekYear,
} from '../../../utils/dateTime';

const Traveldate = ({ props }) => {
  const { t } = useTranslation('booking');
  const {
    periods,
    setPeriod,
    period: selectedPeriod,
    season,
    selectBoxClasses,
  } = props;

  return (
    <Select label={t('Traveldate')} className={`rounded-lg w-full relative`}>
      <select
        id="Traveldate"
        className={`${selectBoxClasses}`}
        onChange={(e) => {
          setPeriod(periods[e.target.value]);
        }}
      >
        {periods &&
          periods.map((period, index) => {
            const monthOut = `MonthShort.${getMonth(period.out)}`;
            const monthIn = `MonthShort.${getMonth(period.home)}`;

            if (season === 'christmas') {
              return (
                <option
                  key={period.out}
                  value={period}
                  selected={
                    selectedPeriod.out === period.out &&
                    selectedPeriod.home === period.home
                  }
                >
                  {getWeekDayShort(period.out)}
                  {getDay(period.out)} {monthOut !== monthIn && t(monthOut)} -{' '}
                  {getWeekDayShort(period.home)}
                  {getDay(period.home)} {t(monthIn)}{' '}
                  {/*getWeekYear(period.out, period.home)*/}
                </option>
              );
            } else
              return (
                <option
                  key={`${period.out}-${period.home}`}
                  value={index}
                  selected={
                    selectedPeriod.out === period.out &&
                    selectedPeriod.home === period.home
                  }
                >
                  {t('Week short')}
                  {getWeek(period.home)} ( {getDay(period.out)}{' '}
                  {monthOut !== monthIn && t(monthOut)} - {getDay(period.home)}{' '}
                  {t(monthIn)}{' '}
                  {season === 'summer' || 'hiking'
                    ? getWeekYear(period.out, period.home)
                    : ''}
                  )
                </option>
              );
          })}
      </select>
    </Select>
  );
};

export default Traveldate;
